<template>
  <v-container>
    <taxMortgageCodesUI />
  </v-container>
</template>

<script>
import taxMortgageCodesUI from '../../components/shared/taxMortgageCodes/taxMortgageCodesList.vue';

export default {
  name: 'taxMortgageCodes',
  components: {
    taxMortgageCodesUI,
  },
};
</script>
